// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtnContainer":"VbPqrS","addToCartBtn":"AlpQKX","iconButton":"DiQZiJ","dummyTextForLoadingWidth":"RYPDxA"};